import { render } from "./XTaskList.vue?vue&type=template&id=477d9a58&scoped=true"
import script from "./XTaskList.vue?vue&type=script&lang=js"
export * from "./XTaskList.vue?vue&type=script&lang=js"

import "./XTaskList.vue?vue&type=style&index=0&id=477d9a58&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477d9a58"]])

export default __exports__